import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListsEmptyPlaceholder',
  setup(__props) {

const router = useRouter();

const emptyPlaceholderImageSrc = `/${ASSETS_DIR}/img/lists/film-reel.svg`;

function navigateToHomePage() {
	router.push({ name: 'app.home' });
}

return { __sfc: true,router, emptyPlaceholderImageSrc, navigateToHomePage, BasicButton }
}

})